module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_sarahperetz.312bc03a.jpg";